<section class="container py-5 mt-5 mb-lg-4 mb-xl-5">
  <!-- Page title-->
  <div class="row pt-xl-3 mt-n1 mt-sm-0">
    <div class="col-lg-9 offset-lg-3 pt-lg-3">
      <h1 class="pb-2 pb-sm-3">Carduri cadou</h1>
    </div>
  </div>

  <gs-gift-cards-list #giftCardsList [showFilters]="true" [filterOutCategories]="[charityCategoryId]"
    [itemsPerPage]="28"></gs-gift-cards-list>


</section>
<!-- Sidebar toggle button-->
<button (click)="giftCardsList.openFilterMenu()"
  class="d-lg-none btn btn-sm fs-sm btn-primary shadow w-100 rounded-0 fixed-bottom"><i class="ai-filter me-2"></i>Filtre</button>
